export var DEFAULT_TRADINGSESSION = '0930-1600';
/** Daily chart intervals. `1` is one minute (intraday), not daily — see `ResolutionValues` in types.ts. */

export var isDailyChartResolution = function isDailyChartResolution(resolution) {
  return resolution === '1D' || resolution === 'Day';
};